import { Link } from "@/components/marketing/elements/link"
import { ArrowNarrowRightIcon } from "@/components/marketing/icons/arrow-narrow-right-icon"
import { ResponsiveAppScreenshot } from "@/components/marketing/ResponsiveAppScreenshot"
import {
  Feature,
  FeaturesTwoColumnWithDemos,
} from "@/components/marketing/sections/features-two-column-with-demos"
import { primaryCtaHref, primaryCtaLabel } from "@/lib/launch-config"

export function MarketingProductFeatures() {
  return (
    <FeaturesTwoColumnWithDemos
      id="features"
      eyebrow="Product"
      headline="Scenarios for reading and checking behavior"
      subheadline={
        <p>
          Each scenario is one plain-language fact about your product — grouped under its feature, linked to the
          behaviors it connects to, and tracked on two independent status axes. The same structured record serves a
          different job for whoever opens it.
        </p>
      }
      features={
        <>
          <Feature
            demo={<ResponsiveAppScreenshot shot="explore" wallpaper="blue" placement="bottom-right" />}
            headline="Read in Explore"
            subheadline={
              <p>
                Scenarios read top to bottom like a document, not a grid of tickets. Nested scenarios, chained
                hand-offs, and cross-feature links appear inline as you scroll. Filter by feature, status, or place —
                Product, Client, or Service surfaces such as The product, Web app, and API.
              </p>
            }
            cta={
              <Link href={primaryCtaHref()}>
                {primaryCtaLabel()} <ArrowNarrowRightIcon />
              </Link>
            }
          />
          <Feature
            demo={<ResponsiveAppScreenshot shot="features" wallpaper="green" placement="bottom-left" />}
            headline="Publish it, then check it"
            subheadline={
              <p>
                Two things get tracked separately: whether the team stands behind a scenario (Draft or Published),
                and whether anyone has checked reality against it (Not attempted, Fit, or Gap). Filter the scenarios
                table before a release to find what you stand behind but nobody has verified.
              </p>
            }
            cta={
              <Link href={primaryCtaHref()}>
                {primaryCtaLabel()} <ArrowNarrowRightIcon />
              </Link>
            }
          />
        </>
      }
    />
  )
}
